import { ModalGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

export const SendToApproveModal = ({
  handleSendToApprove,
  isReturnedLinesWithOutEdit,
  noLinesToSend,
  setShowSendToApproveModal,
  showSendToApproveModal
}) => (
  <ModalGeneric
    backdrop="static"
    disabled
    infoModal
    onHide={() => setShowSendToApproveModal(false)}
    primaryAction={handleSendToApprove}
    primaryActionDisabled={noLinesToSend}
    primaryActionLabel="Enviar"
    secondaryAction={() => setShowSendToApproveModal(false)}
    secondaryActionLabel="Salir"
    show={showSendToApproveModal}
    size="sm"
    title="Enviar a aprobar"
    variantHeader="light"
  >
    <>
      {isReturnedLinesWithOutEdit && (
        <span>
          <b>
            Hay cantidades devueltas que no fueran editadas y se van a aprobar automaticamente
            ¿Estas seguro que lo vas a enviar?.
          </b>
          <br />
        </span>
      )}
      {noLinesToSend ? (
        <span>
          <b>No ingreso cantidades para enviar</b>
          <br />
        </span>
      ) : null}
      <br />
      <span>¿Estás seguro que desea enviar a aprobar las cantidades modificadas?</span>
    </>
  </ModalGeneric>
);

SendToApproveModal.propTypes = {
  handleSendToApprove: PropTypes.func.isRequired,
  isReturnedLinesWithOutEdit: PropTypes.bool.isRequired,
  setShowSendToApproveModal: PropTypes.func.isRequired,
  showSendToApproveModal: PropTypes.bool.isRequired,
  noLinesToSend: PropTypes.bool.isRequired
};

export default SendToApproveModal;
